import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostBinding,
  inject,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { AppStore } from '@app-store';

import { AuthStore } from '@pages/auth/auth-store';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { MobileMainMenuComponent } from './mobile-main-menu/mobile-main-menu.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [CommonModule, RouterModule, MatIconModule, MainMenuComponent, MobileMainMenuComponent]
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input()
  @HostBinding('class.transparent')
  transparent = false;

  // Computed properties for better performance
  readonly menuItems = computed(() => this.appStore.mainMenuItems());
  readonly user = computed(() => this.authStore.userInfo());
  readonly authInfor = computed(() => this.authStore.authInfo());

  mobileMenuOpen = false;

  private readonly authStore = inject(AuthStore);
  private readonly appStore = inject(AppStore);

  ngOnDestroy(): void {
    document.body.classList.remove('no-scroll');
  }

  ngOnInit(): void {
    this.appStore.fetchMainMenuItems();
  }

  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;

    if (this.mobileMenuOpen) {
      (window as any).scrollTo({ top: 0, behavior: 'smooth' });
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }
}
